export default "__VITE_ASSET__hke7X8uN__"